import { exposeItems } from "@/mocks/tracking";

const flagStyle: Record<string, string> = {
  新: "bg-mark-soft text-mark-text",
  热: "bg-ink text-cream",
  持续: "bg-gold-soft text-gold-text",
};

export default function ExposeGrid() {
  return (
    <section id="expose" className="w-full border-b border-line">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-gold-text">
              Fresh Drops
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink md:text-3xl">
              新瓜速览 · 近期流出
            </h2>
            <p className="mt-2 text-sm text-muted">
              标题优先、信息克制，给刚出的新瓜留一点被完整阅读的空间。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {exposeItems.map((it) => (
            <a
              key={it.index}
              href="#verify"
              className="group flex flex-col rounded-lg border border-line bg-card p-5 transition-colors hover:border-mark/40 hover:bg-cream"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs tracking-wider text-faint">{it.index}</span>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-faint">热度 {it.hot}</span>
                  <span
                    className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${flagStyle[it.flag]}`}
                  >
                    {it.flag}
                  </span>
                </div>
              </div>

              <h3 className="mt-3 font-heading text-base font-bold leading-snug text-ink md:text-lg">
                {it.title}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-muted md:text-sm">
                {it.summary}
              </p>

              <div className="mt-4 flex items-center justify-between border-t border-line pt-3">
                <span className="text-xs text-faint">{it.meta}</span>
                <span className="inline-flex items-center gap-1 text-xs text-mark-text group-hover:text-mark-deep">
                  读详情 <i className="ri-arrow-right-up-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}